import type React from 'react';

import { MaintenanceBanner } from '../components/MaintenanceBanner';
import { useMaintenanceBanner } from '../hooks/maintenanceBanner';

export const MaintenanceBannerContainer: React.FC<EmptyProps> = () => {
	const maintenanceBannerMessage = useMaintenanceBanner();

	if (!maintenanceBannerMessage) return null;

	return <MaintenanceBanner message={maintenanceBannerMessage} />;
};
